export const langTraductions = {
    en: {
        error: 'Bad language!!',
    },
    fr: {
        error: 'La langue choisie n\'est pas autorise!! Veuillez choisir entre l\'anglais et le français.',
    }
}